<div class="preloader" v-if="preloader"></div>
<div :class="wrapperClassPrep" v-else>
    <input :checked="isChecked" @change="changeToParent" v-bind="attributesPrep"/>
    <label :title="title" :for="attributesPrep.id">
        <i class="icon check"></i>{{ label }} <Help v-if="helpText.length > 0" :text="helpText" class="ml-1" />
    </label>
</div>
